import { GpsType } from '../../../../../../global/components/layout/layout-models';
import { AccountInfoRoutes } from '../../../../../account-info/constants/routes';
import { PersonalInfoWizard } from '../../../../../account-info/features/personal-info/wizard/personal-info-wizard';
import { BenefitEnrollmentStep } from '../../models/pension-enrollment-models';
import { setCurrentNewHireBenefitEnrollmentStep } from '../../slice/new-hire-enrollment-slices';



export class NewHireMemberEnrollmentPersonalInfoWizard extends PersonalInfoWizard {

	public getPageDescription(): string {
		return this.epiContent?.personalInfoSettingState?.epiContent?.newHireMemberPageIntro;
	}

	public useEffectDispatch(): void {
		this.dispatch(setCurrentNewHireBenefitEnrollmentStep(BenefitEnrollmentStep.PERSONAL_INFORMATION));
	}

	public onSuccessRedirect(basePath: string): void {
		this.history.push(`${basePath}${AccountInfoRoutes.RelationshipsSegment}`);
	}

	// eslint-disable-next-line class-methods-use-this
	public isEnrollmentForm(): boolean {
		return true;
	}

	// eslint-disable-next-line class-methods-use-this
	public getGpsType(): GpsType {
		return GpsType.MEMBER_NEW_HIRE_PERSON_INFO;
	}

	// eslint-disable-next-line class-methods-use-this
	public hasMaritalStatusSection(): boolean {
		return true;
	}


	public getSubmitButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent?.benefitEnrollmentPersonalInfoContinueText;
	}

	public getCancelButtonText() {
		return this.epiContent?.newHireSettingsState?.epiContent.benefitEnrollmentPersonalInfoBackText;
	}
}